import OEColorModel from '../../../lib/color/oe-color-model';


export default class OEImplantcastColorModel extends OEColorModel {

    stdBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: opacity} : {x: 0.15, y: 0.195, z: 0.19, w: opacity};
    }

    stdActiveBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: opacity} : {x: 0.15, y: 0.195, z: 0.19, w: opacity};
    }

    stdHoverBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.05, y: 0.095, z: 0.09, w: opacity} : {x: 0.2, y: 0.245, z: 0.24, w: opacity};
    }

    stdActiveHoverBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.05, y: 0.095, z: 0.09, w: opacity} : {x: 0.2, y: 0.245, z: 0.24, w: opacity};
    }

    lightBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.5} : {x: 0.15, y: 0.195, z: 0.19, w: 0.5};
    }

    lightActiveBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.6} : {x: 0.3, y: 0.39, z: 0.38, w: 0.6};
    }

    lightHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.05, y: 0.095, z: 0.09, w: 0.6} : {x: 0.35, y: 0.44, z: 0.43, w: 0.6};
    }

    lightActiveHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.6} : {x: 0.3, y: 0.39, z: 0.38, w: 0.6};
    }

    extraLightBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.3} : {x: 0.15, y: 0.195, z: 0.19, w: 0.3};
    }

    extraLightActiveBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.4} : {x: 0.3, y: 0.39, z: 0.38, w: 0.4};
    }

    extraLightHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.05, y: 0.095, z: 0.09, w: 0.4} : {x: 0.35, y: 0.44, z: 0.43, w: 0.4};
    }

    extraLightActiveHoverBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.4} : {x: 0.3, y: 0.39, z: 0.38, w: 0.4};
    }

    stdToolbarBackgroundColor(brightness)  {
        var opacity = this.stdBgOpacity(brightness);
        return this.brightMode(brightness) ? {x: 0.05, y: 0.095, z: 0.09, w: opacity} : {x: 0.1, y: 0.145, z: 0.14, w: opacity};
    }

    viewBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.4} : {x: 0.15, y: 0.195, z: 0.19, w: 0.4};
    }

    startViewBackgroundColor(brightness)  {
        return this.brightMode(brightness) ? {x: 0.0, y: 0.045, z: 0.04, w: 0.6} : {x: 0.15, y: 0.195, z: 0.19, w: 0.6};
    }
}